import { toast } from "sonner";

// Safely copy text to the clipboard. Never throws (clipboard can be denied in
// insecure contexts or without a user gesture). Toasts on the outcome.
export async function copyToClipboard(text, successMsg = "Copied!") {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      toast.success(successMsg);
      return true;
    }
    throw new Error("clipboard unavailable");
  } catch (_) {
    // Legacy fallback via a hidden textarea.
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      if (ok) { toast.success(successMsg); return true; }
      throw new Error("execCommand failed");
    } catch (_e) {
      toast.info("Couldn't copy automatically — copy the link shown below.");
      return false;
    }
  }
}
